import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import EditProfileModal from './EditProfileModal';
import ChangePasswordModal from './ChangePasswordModal';
import './UserMenu.css';

function UserMenu({ collapsed, onLogout }) {
  const { user } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [editProfileOpen, setEditProfileOpen] = useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleEditProfile = () => {
    setDropdownOpen(false);
    setEditProfileOpen(true);
  };

  const handleChangePassword = () => {
    setDropdownOpen(false);
    setChangePasswordOpen(true);
  };

  const handleLogout = () => {
    setDropdownOpen(false);
    onLogout();
  };

  if (!user) return null;

  return (
    <>
      <div className={`user-menu ${collapsed ? 'collapsed' : ''}`} ref={dropdownRef}>
        {!collapsed && (
          <div className="user-info">
            <div className="user-avatar">
              {user.nome.charAt(0).toUpperCase()}
            </div>
            <div className="user-details">
              <div className="user-name">{user.nome}</div>
              <div className="user-role">
                {user.role === 'admin' ? 'Administrador' : 'Usuário'}
              </div>
            </div>
          </div>
        )}

        <button
          className={`user-menu-button ${collapsed ? 'collapsed' : ''}`}
          onClick={toggleDropdown}
          title="Menu do usuário"
        >
          {collapsed ? (
            <div className="user-avatar-small">
              {user.nome.charAt(0).toUpperCase()}
            </div>
          ) : (
            '⚙️'
          )}
        </button>

        {dropdownOpen && (
          <div className={`user-menu-dropdown ${collapsed ? 'from-center' : ''}`}>
            <button className="menu-item" onClick={handleEditProfile}>
              <span className="menu-icon">👤</span>
              <span>Editar Perfil</span>
            </button>
            <button className="menu-item" onClick={handleChangePassword}>
              <span className="menu-icon">🔒</span>
              <span>Alterar Senha</span>
            </button>
            <div className="menu-divider"></div>
            <button className="menu-item logout" onClick={handleLogout}>
              <span className="menu-icon">🚪</span>
              <span>Sair</span>
            </button>
          </div>
        )}
      </div>

      <EditProfileModal
        isOpen={editProfileOpen}
        onClose={() => setEditProfileOpen(false)}
      />

      <ChangePasswordModal
        isOpen={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
      />
    </>
  );
}

export default UserMenu;
